import Vue from 'vue'
import VueRouter from 'vue-router'
import { sync } from 'vuex-router-sync'
import store from '@/store'
import routes from './routes'
import auth from '@/auth'
import _ from 'lodash'

Vue.use(VueRouter)

let router = new VueRouter({
  routes: routes,
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

const protectedRoute = route => {
  let isRouteProtected = false
  _(route.matched).forEach(element => {
    if (element.meta.auth) {
      isRouteProtected = true
    }
  })
  return isRouteProtected
}

const authorizedRoute = route => {
  let isRouteProtected = false
  let isRouteAuthorized = false
  _(route.matched).forEach(element => {
    if (element.meta.auth) {
      isRouteProtected = true
    }
    if (isRouteProtected && element.meta.roles) {
      isRouteAuthorized = auth.hasRoles(element.meta.roles)
    }
  })
  return isRouteProtected && isRouteAuthorized
}

router.beforeEach((to, from, next) => {
  if (protectedRoute(to)) {
    if (authorizedRoute(to) && auth.getAccessToken()) {
      next()
    } else {
      let route = '/'
      if (auth.hasRoles(['owner', 'manager', 'employee'])) {
        route = '/organization'
      }
      next({
        path: route
      })
    }
  }
  next()
})

sync(store, router)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js